module.exports = {
    title:'${num_of_books} Expert Book Recommendations in ${category} (Updated Daily)',
    description: '${num_of_books} Book Recommendations in ${category}',
}